import * as React from 'react'
import styled from 'styled-components'
import { animated, SpringValue, AnimatedComponent } from '@react-spring/web'

type StaticPaperProps = {
  elevation: number
  opacity?: SpringValue<number>
  shadowOpacity?: SpringValue<number>
  // next: { elevation: number; opacity: number }
}

const StaticPaper = styled(animated.div)<StaticPaperProps>`
  --border-radius: 3px;
  --elevation-0: none;
  --elevation-1: 0 1.2px 4.7px rgba(0, 0, 0, 0.002), 0 3px 12px rgba(0, 0, 0, 0.007),
    0 6.2px 24.5px rgba(0, 0, 0, 0.018), 0 12.8px 50.4px rgba(0, 0, 0, 0.042),
    0 35px 138px rgba(0, 0, 0, 0.15);
  --opacity-next: 1;
  --opacity: 0;
  position: relative;
  background: white;
  &,
  &:before,
  &:after {
    border-radius: var(--border-radius);
  }
  &:before,
  &:after {
    z-index: -1;
    left: 0;
    top: 0;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }
  &:before  {
    box-shadow: ${props => `var(--elevation-${props.elevation})`};
    opacity: --opacity;
  }
`

type PaperSahdowProps = {
  elevation: 0 | 1
}

const PaperShadow = styled(animated.figure)<PaperSahdowProps>`
  --elevation-0: none;
  --elevation-1: 0 1.2px 4.7px rgba(0, 0, 0, 0.002), 0 3px 12px rgba(0, 0, 0, 0.007),
    0 6.2px 24.5px rgba(0, 0, 0, 0.018), 0 12.8px 50.4px rgba(0, 0, 0, 0.042),
    0 35px 138px rgba(0, 0, 0, 0.15);
  box-shadow: ${props => `var(--elevation-${props.elevation})`};
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  border-radius: inherit;
  z-index: -1;
`

const PaperBox = styled(animated.div)<{
  style?: { ['--o']?: SpringValue<number> | number } & AnimatedComponent<any>['style']
}>`
  position: relative;
  border-radius: 3px;
  ${props =>
    props.style?.['--o'] &&
    `&:before {
      border-radius: inherit;
      z-index: -1;
      opacity: var(--o);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: '';
      position: absolute;
      box-shadow: 0 1.2px 4.7px rgba(0, 0, 0, 0.002),
        0 3px 12px rgba(0, 0, 0, 0.007), 0 6.2px 24.5px rgba(0, 0, 0, 0.018),
        0 12.8px 50.4px rgba(0, 0, 0, 0.042), 0 35px 138px rgba(0, 0, 0, 0.15);
    }`}
`

type PaperProps = {
  elevation?: number
  shadowOpacity?: SpringValue<number> | number
  style?: React.CSSProperties
  contentProps?: any
  children?: React.ReactNode
}

const PaperContent = styled(animated.article)`
  height: auto;
  width: 100%;
  padding: 32px 24px 8px;
  box-sizing: border-box;
  border-radius: 3px;
  background: rgb(255, 255, 255);
  overflow: hidden;
  & & {
    padding: 0 0 8px;
  }
`

const Paper = React.forwardRef<HTMLElement, PaperProps>(
  ({ elevation = 1, shadowOpacity, children, style, contentProps }, ref) => {
    return (
      <StaticPaper
        {...{
          elevation,
          style: {
            ...(style as any),
            '--opacity': shadowOpacity
          }
        }}
      >
        <PaperContent {...{ ...contentProps, ref, children }} />
      </StaticPaper>
    )
  }
)

Paper.displayName = 'Paper'

export { Paper, PaperShadow, PaperBox, PaperContent }
